import { ReactNode } from "react";
import { TooltipText, TooltipWrapper } from "./Tooltip.styles";

export interface TooltipProps {
  title: string;
  children: ReactNode;
  position?: "top" | "bottom" | "left" | "right" | "inputInfo";
  width?: "full" | "auto";
  align?: "center" | "start" | "end"| "safeEnd";
  className?: string;
  wrapperAs?: "div" | "span";
}

const Tooltip = ({
  title,
  children,
  position = "bottom",
  width = "full",
  align = "center",
  className,
  wrapperAs = "div",
}: TooltipProps) => {
  return (
    <TooltipWrapper as={wrapperAs} className={className} width={width}>
      {children}
      <TooltipText
        className="tooltip"
        position={position}
        align={align}
        role="tooltip"
      >
        {title}
      </TooltipText>
    </TooltipWrapper>
  );
};

export default Tooltip;
